import { useReducer } from 'react';
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import reducer, { defaultState, updateFieldCreator } from './reducer';
import {
  createIpmaCisCreator,
  setIpmaCisCreateErrorsCreator,
} from '../../../../../store/actionsCreators';
import AddCertificateHolder from '../../../../../shared/Cis/CertificateHolders/Add/AddCertificateHolder';

const AddIpmaCertificateHolder = ({
  errors,
  createCertificateHolder,
  removeError,
  created,
}) => {
  const [state, dispatch] = useReducer(reducer, defaultState);

  return (
    <AddCertificateHolder
      state={state}
      dispatch={dispatch}
      updateFieldCreator={updateFieldCreator}
      errors={errors}
      createCertificateHolder={createCertificateHolder}
      removeError={removeError}
      created={created}
    />
  );
};

AddIpmaCertificateHolder.propTypes = {
  errors: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    email: PropTypes.string,
    title: PropTypes.string,
    middleName: PropTypes.string,
    birthDate: PropTypes.string,
    status: PropTypes.string,
  }),
  createCertificateHolder: PropTypes.func.isRequired,
  removeError: PropTypes.func.isRequired,
  created: PropTypes.shape({
    value: PropTypes.number,
    label: PropTypes.string,
  }),
};

AddIpmaCertificateHolder.defaultProps = {
  errors: {},
  created: {},
};

const mapStateToProps = ({ ipma }) => ({
  errors: ipma.cis.certificateHolders.createErrors,
  created: ipma.cis.certificateHolders.created,
});

const mapDispatchToProps = (dispatch) => ({
  createCertificateHolder: (payload, history) =>
    dispatch(createIpmaCisCreator('certificateHolders', payload, history, false)),
  removeError: (payload) => dispatch(setIpmaCisCreateErrorsCreator('certificateHolders', payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddIpmaCertificateHolder);
